import { Tooltip } from '@mui/material';
import React from 'react';
import Input from 'shared/component/inputFields';
import TextArea from 'shared/component/textArea';
import {  useCreateOrder } from "customer/orders/create-order/create-order.service";
import { localize } from "shared/helpers/utils";


const units = [{
  id:1,
  name: "Ton"
}]

const ShippingDetails = (props) => {
  const {shippingDetailsForm,setOrderData,customers,vehicles,goodTypes} = useCreateOrder();
  const {register,handleSubmit,formState:{errors}} = shippingDetailsForm

  const next = data => {
    setOrderData(d => ({...d,...data}));
    props.nextStep();
  }

    return (
        <form onSubmit={handleSubmit(next)} className='myorder'>
            <div className='container'>
            <div className='steps'>
                    <Tooltip title="NEW ORDER" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="SHIPPING DETAILS" arrow>
                        <span className='indicator active'></span>
                    </Tooltip>
                    <Tooltip title="FROM DETAILS" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                    <Tooltip title="TO DETAILS" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                    <Tooltip title="DESTINATIONS" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                    <Tooltip title="SUMMARY" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                    <Tooltip title="PENDING" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                </div>

                <div className='box-order'>
                    <div className='order-header'>
                        <h1 className='title'>SHIPPING DETAILS</h1>
                        <hr className='hr' />
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <Input type="select" label="Customer Name:" error={errors.customer?.message} {...register('customer')} getOptionValue={c=> c.id} options={customers} getOptionLabel={l => localize(l.name)}/>
                        </div>
                        <div className='col-md-6'>
                            <Input type="select" label="Vehicle Type:" error={errors.vehicle?.message} {...register('vehicle')} options={vehicles} getOptionLabel={v => localize(v.name)} />
                        </div>
                    </div>
                    <h2 className='title2'>Goods Details</h2>
                    <div className='row'>
                        <div className='col-md-6'>
                            <Input type="select" label="Goods Type:" error={errors.goodsType?.message} {...register('goodsType')} options={goodTypes} getOptionLabel={g => localize(g.name)}/>
                        </div>
                        <div className='col-md-2'>
                            <Input type="text" label="Weight:" error={errors.weight?.message} {...register('weight'  ) }/>
                        </div>
                        <div className='col-md-2'>
                            <Input type="select" label="Unit" error={errors.unit?.message} options={units} {...register('unit')}  />
                        </div>
                        <div className='col-md-2'>
                            <Input type="text" label="price:"  error={errors.price?.message} {...register('price')} />
                        </div>
                        <div className='col-md-12'>
                            <TextArea label="Goods Discerption:"  error={errors.goodDescription?.message} {...register('goodDescription')} />
                        </div>
                    </div>
                </div>
            </div>

          <div className='action'>
            <div className='container'>
              <button type='button' className='btn-border-blue' onClick={props.previousStep}>Back</button>
                <button type='submit' className='btn-blue'>Next</button>
            </div>
          </div>

        </form>
    )
}

export default ShippingDetails